import type { FunctionComponent } from 'react'
import { useState } from 'react'
import React, { useContext, useEffect } from 'react'

import { bankData } from '../../../../shared/data/bankData'
import { SingleDropDownPage } from '../../../../shared/pages/SingleDropDownPage'
import { ToolContext } from '../../../../shared/state/appContext'
import { formatToolName } from '../../../../shared/utils/formatToolName'
import { generalDataLayer } from '../../../../shared/utils/tracking'
import { ReportedToFlow, WhatBankFlow } from '../../pageFlowData'
import { whatBankData } from './data'

export const WhatBank: FunctionComponent = () => {
  const { state, dispatch } = useContext(ToolContext)
  const {
    initial: { entryToolName },
    victim: { whatBank },
  } = state

  const [isInputValid, setIsInputValid] = useState<boolean>(true)
  const [selectValue, setSelectValue] = useState(whatBank)

  useEffect(() => {
    const index = bankData.findIndex((x) => x.label === 'Please select an option')
    if (index === -1) {
      bankData.unshift({ label: 'Please select an option', value: '' })
    }
  }, [])

  const handleDispatch = (value: string) => {
    dispatch({ type: 'UPDATE_WHAT_BANK', data: value })
    dispatch({ type: 'UPDATE_STEP', data: ReportedToFlow.STEP })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: ReportedToFlow.PROGRESS_VALUE })
  }

  const handleTracking = (value: string) => {
    const trackingAnswer = `question | ${WhatBankFlow.VIEW_NAME} | ${value}`
    generalDataLayer(formatToolName(entryToolName), trackingAnswer, false)
  }

  const handleSubmit = () => {
    if (!selectValue) {
      setIsInputValid(false)
      return
    }

    setIsInputValid(true)
    handleDispatch(selectValue)
    handleTracking(selectValue)
  }

  const handleSelectChange = (selectedOption: string) => {
    setSelectValue(selectedOption)
    setIsInputValid(true)
  }

  const { question, imgObj, id } = whatBankData

  return (
    <div data-testid="how-account-sold">
      <SingleDropDownPage
        buttonText="Next"
        defaultValue={whatBank}
        handleSubmit={handleSubmit}
        id={id}
        imgObj={imgObj}
        isInputValid={isInputValid}
        onChangeCallback={handleSelectChange}
        options={bankData}
        title={question}
      />
    </div>
  )
}
